import { UrlUtil } from '@everfi/reactifi';

const getMatchWithParams = path => {
  // Collection URLs must be checked before the generic explore_courses check
  if (path.indexOf('/teacher/explore_courses/collection/') > -1) {
    const collectionID = path.split('/')[4];
    return `teacher/collections/${collectionID}?slug=catalog`;
  }

  if (path.indexOf('/teacher/explore_courses') > -1) {
    const curriculumID = path.split('/')[3];
    return `teacher/content/${curriculumID}?slug=catalog`;
  }

  if (path.indexOf('/teacher/my_classes/edit') > -1) {
    const classId = path.split('/')[4];
    return `teacher/classes/${classId}/edit?title_slug=classes`;
  }

  if (path.indexOf('/teacher/my_classes') > -1) {
    const courseID = path.split('/')[3];
    return `teacher/reports?cohort_id=${courseID}`;
  }

  return 'teacher/catalog';
};

export const getHomeRoomOldUrl = path => {
  switch (UrlUtil.PathHelper.ensureEndSlash(path)) {
    case '/teacher/explore_courses/my_courses/':
    case '/teacher/explore_courses/all_courses/':
      return 'teacher/catalog';

    case '/teacher/my_classes/':
      return 'teacher/classes';

    case '/teacher/my_classes/edit/add/':
      return 'teacher/classes/new?title_slug=classes';

    default:
      return getMatchWithParams(path);
  }
};

export function formatSchoolYears(schoolYears = {}) {
  return {
    school_year: Object.entries(schoolYears).map(([key, label]) => ({
      id: key,
      label,
      value: key,
    })),
  };
}
